import CallToAction from 'contentful/shared/call_to_action';
import {
  CalendarIcon,
  LocationPinOutlinedIcon,
  PersonIcon,
  TicketIcon,
} from 'assets/icons';

const EventDetail = ({ title, content, icon }) => (
  <div className="event-detail">
    {icon && <div className="event-detail__icon">{icon}</div>}
    <div className="event-detail__info">
      <h5 className="event-detail__title fs-20 ff-body mt-0 mb-6">{title}</h5>
      <p className="event-detail__content fs-14 mb-0">{content}</p>
    </div>
  </div>
);

const EventSidebar = ({
  registerButton,
  dateTime,
  location,
  standNumber,
  freeToAttendDescription,
  freeToAttendTitle,
  className = '',
}) => (
  <aside className={`event__sidebar mb-44 l-mb-0 ${className}`}>
    <div className="event__sidebar__inner">
      {registerButton && (
        <CallToAction
          id={registerButton.sys.id}
          content={registerButton.fields}
          newTab
        />
      )}
      {dateTime && (
        <EventDetail title="Date" content={dateTime} icon={<CalendarIcon />} />
      )}
      {location && (
        <EventDetail
          title="Location"
          content={location}
          icon={<LocationPinOutlinedIcon width={24} height={24} />}
        />
      )}
      {standNumber && (
        <EventDetail
          title="Stand"
          content={standNumber}
          icon={<PersonIcon />}
        />
      )}
      {freeToAttendDescription && freeToAttendTitle && (
        <EventDetail
          title={freeToAttendTitle}
          content={freeToAttendDescription}
          icon={<TicketIcon />}
        />
      )}
    </div>
  </aside>
);

export default EventSidebar;
